import {Component, OnInit} from '@angular/core';
import {ModalController, NavController} from '@ionic/angular';
import {EditBonusPage} from '../edit-bonus/edit-bonus.page';
import {ActivatedRoute} from '@angular/router';
import {DataStore} from '@aws-amplify/datastore';
import {Bonus} from '../../models';

@Component({
  selector: 'app-bonus',
  templateUrl: './bonus.page.html',
  styleUrls: ['./bonus.page.scss'],
})
export class BonusPage implements OnInit {
  bonusId;
  currentBonus;

  constructor(
    private route: ActivatedRoute,
    private navController: NavController,
    private modalController: ModalController,
  ) { }

  async ngOnInit() {
    await this.route.params.subscribe(params => {
        this.bonusId = params['bonusId'];
    });

    this.refreshBonus();
  }

  async editBonus() {
    const modal = await this.modalController.create({
        component: EditBonusPage,
        componentProps: {bonusId: this.currentBonus.id},
        cssClass: 'custom-modal',
    });
    await modal.present();
    await modal.onWillDismiss().then(data => {
        this.refreshBonus();
    })
  }

  async deleteBonus(bonusId: string) {
    if (confirm("Do you really want to delete this Bonus")) {
        await DataStore.delete(Bonus, bonusId);
        this.back();
    }
  }

  private async refreshBonus() {
    this.currentBonus = await DataStore.query(Bonus, this.bonusId);
  }

  back() {
    this.navController.back();
  }


}
